import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const InactiveRequestRedirect = ({ requestStatus }) => {
  const history = useHistory();

  useEffect(() => {
    if (requestStatus === 'INACTIVE') {
      history.push('/protocol-setup/browser');
    }
  }, [requestStatus, history]);

  return null;
};

export default InactiveRequestRedirect;
